import { Environment } from 'src/app/classes/environment';
// import { version } from '../../package.json';
import packageInfo from '../../package.json';


// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = new Environment();
environment.production = false;
environment.version = packageInfo.version;
// backend = 'http://10.10.1.210/mp_backend/api/'

// environment.recaptchaKey = "6LcqLK4cAAAAAGmAgtPHJ1TSL4aPUopgAxs9zhL4";

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
